import { AccessManagementAccountGetResponse } from '@surglogs-app/network'

export type FIELD = keyof AccessManagementAccountGetResponse

export const FORM_FIELDS = [
  'email',
  'first_name',
  'last_name',
  'middle_name',
  'other_names',
  'dob',
  'daytime_number',
  'cell_number',
  'ssn',
  'npi',
  'address',
  'title',
] as FIELD[]
